export enum GroupingStagePool {
  Overall = "OVERALL",
  Stage = "STAGE",
  StagePool = "STAGEPOOL",
}
